import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getShortAddress,getShortAddressbyId,editShortAddressbyId,deleteShortAddressbyId, 
  importShortAddress,exportShortAddress,getShortAddressHistory,getShortAddressHistorybyNational,
  getShortAddressHistorybyGeoLocation,exportShortAddressHistory,getBlacklistCodesService,
  addBlacklistCodeService,deleteBlacklistCodeService,downloadBlacklistCodeService,
  uploadBlacklistCodeService,
  downloadBlacklistTemplateService
  } from "../../services/ShortAddress/ShortAddress_Services";
const initialValues = {
  isBlacklistDeleted: false,
};
let shortAddressStore = (set) => ({
  ...initialValues,
  setIsBlacklistDeleted: (value) => set({ isBlacklistDeleted: value }),
  getShortAddress: async (params,params2) => {
        const response = await getShortAddress(params,params2);
        return response;
      },
      getShortAddressbyId: async (params,params2) => {
        const response = await getShortAddressbyId(params,params2);
        return response;
      },
      editShortAddressbyId: async (params,params2,data) => {
        const response = await editShortAddressbyId(params,params2,data);
        return response;
      },
      deleteShortAddressbyId: async (params,params2) => {
        const response = await deleteShortAddressbyId(params,params2);
        return response;
      },
      importShortAddress: async (params,data) => {
        const response = await importShortAddress(params,data);
        return response;
      },
      exportShortAddress: async (params,params2) => {
        const response = await exportShortAddress(params,params2);
        return response;
      },
      getShortAddressHistory: async (params,params2) => { 
        const response = await getShortAddressHistory(params,params2);
        return response;
      },
      getShortAddressHistorybyNational: async (params,params2,params3) => {
        const response = await getShortAddressHistorybyNational(params,params2,params3);
        return response;
      },
      getShortAddressHistorybyGeoLocation: async (params,params2) => {
        const response = await getShortAddressHistorybyGeoLocation(params,params2);
        return response;
      },
      exportShortAddressHistory: async (params,params2) => {
        const response = await exportShortAddressHistory(params,params2);
        return response;
      },
      getBlacklistCodesAction: async (paginationParams, sortingParams, filterParams) => {
        const response = await getBlacklistCodesService(paginationParams, sortingParams, filterParams);
        return response;
      },
      addBlackListCodeAction: async (params) => {
        const response = await addBlacklistCodeService(params);
        return response;
      },
      deleteBlackListCodeAction: async (params) => {
        const response = await deleteBlacklistCodeService(params);

        if (response?.data?.status === "SUCCESS") {
          set({ isBlacklistDeleted: true });
        }
        
        return response;
      },
      downloadBlacklistCodeAction: async (paginationParams, sortingParams, filterParams) => {
        const response = await downloadBlacklistCodeService(paginationParams, sortingParams, filterParams);
        return response;
      },
      downloadBlacklistTemplateAction: async () => {
        const response = await downloadBlacklistTemplateService();
        return response;
      },
      uploadBlacklistCodeAction: async (formData) => {
        const response = await uploadBlacklistCodeService(formData);
        return response;
      },
});

shortAddressStore = devtools(shortAddressStore);

export const useShortAddressStore = create(shortAddressStore);